import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

const initialState = {
	error: null,
	loading: true,
	speakers: null,
	speaker: [],
	speakerLoading: null,
};

export const getSpeakerDetails = createAsyncThunk(
	"spekaer/details",
	async ({ organiserID, eventID, language, id }) => {
		const REACT_APP_API_URL = process.env.REACT_APP_API_URL;
		const REACT_APP_ENV = process.env.REACT_APP_ENV;
		const REACT_APP_API_URL_TEST = process.env.REACT_APP_API_URL_TEST;

		try {
			const baseUrl =
				REACT_APP_ENV === "prod" ? REACT_APP_API_URL : REACT_APP_API_URL_TEST;
			let url = `${baseUrl}/api/speaker/public/getById/${organiserID}/${eventID}/${id}/${language}`;

			const res = await axios({
				method: "get",
				url: url,
				headers: {
					"Content-Type": "application/json",
				},
			});
			return res.data;
		} catch (error) {
			throw new Error("Bir Hata Oluştu: Get detail speakers");
		}
	}
);

export const getSpeakers = createAsyncThunk(
	"speakers/getAll",
	async ({ organiserID, eventID, language, topics, limit }) => {
		const REACT_APP_API_URL = process.env.REACT_APP_API_URL;
		const REACT_APP_ENV = process.env.REACT_APP_ENV;
		const REACT_APP_API_URL_TEST = process.env.REACT_APP_API_URL_TEST;

		try {
			const baseUrl =
				REACT_APP_ENV === "prod" ? REACT_APP_API_URL : REACT_APP_API_URL_TEST;

			let url = `${baseUrl}/api/speaker/public/${organiserID}/${eventID}/${language}`;

			// Query parametrelerini oluştur
			const queryParams = new URLSearchParams();

			if (topics && topics.trim() !== "") {
				queryParams.append("topics", topics);
			}
			if (limit) {
				queryParams.append("limit", limit);
			}

			// Eğer query parametreleri varsa, url'ye ekle
			const queryString = queryParams.toString();
			if (queryString) {
				url += `?${queryString}`;
			}

			const res = await axios({
				method: "get",
				url: url,
				headers: {
					"Content-Type": "application/json",
				},
			});
			return [topics, res?.data?.speakers];
		} catch (error) {
			throw new Error("Bir Hata Oluştu: Get all speakers");
		}
	}
);

export const speakersSlice = createSlice({
	name: "speakers",
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder
			.addCase(getSpeakers.pending, (state) => {
				state.loading = true;
				state.error = null;
			})
			.addCase(getSpeakers.fulfilled, (state, action) => {
				state.loading = false;
				state.error = null;
				state.speakers = {
					...state.speakers,
					[action.payload[0]]: action.payload[1],
				};
			})
			.addCase(getSpeakers.rejected, (state, action) => {
				state.loading = false;
				state.error = action.error.message;
			})

			// spekaer details
			.addCase(getSpeakerDetails.pending, (state) => {
				state.speakerLoading = true;
				state.error = false;
				state.speaker = null;
			})

			.addCase(getSpeakerDetails.fulfilled, (state, action) => {
				state.speakerLoading = null;
				state.error = false;
				state.speaker = action.payload;
			})

			.addCase(getSpeakerDetails.rejected, (state, action) => {
				state.speakerLoading = null;
				state.error = action.error.message;
				state.speaker = null;
			});
	},
});

export default speakersSlice.reducer;
